import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiChevronDown, FiChevronUp, FiMapPin, FiPhone } from "react-icons/fi";
import { MdOutlineEmail, MdOutlineKeyboardArrowRight } from "react-icons/md";
import logo from '../../Assets/logo-1.png';

const Navbar = () => {
  const [tuitionOpen, setTuitionOpen] = useState(false);
  const [boardExamOpen, setBoardExamOpen] = useState(false);
  const [entranceExamOpen, setEntranceExamOpen] = useState(false);
  const [competitiveExamOpen, setCompetitiveExamOpen] = useState(false);

  return (
    <div className="max-w-screen-xl mx-auto py-2 px-4">
      {/* Top Section */}
      <div className="flex items-center justify-between border-b pb-2">
        {/* Logo */}
        <div>
          <img src={logo} alt="Logo" className="h-[80px] object-contain" />
        </div>

        {/* Contact Details */}
        <div className="flex space-x-6">
          <div className="flex items-center space-x-2">
            <span className="bg-[#1ba6db] p-2 rounded-md text-white"><FiMapPin size={20} /></span>
            <div>

              <h1 className="font-semibold text-gray-700 text-sm">Address</h1>
              <p className="text-xs text-gray-600">4th Cross Street, near TollGate</p>  
            </div>
          </div>

          <div className="flex items-center space-x-2">
            <span className="bg-[#1ba6db] p-2 rounded-md text-white"><MdOutlineEmail size={20} /></span>
            <div>
              <h1 className="font-semibold text-gray-700 text-sm">Email</h1>
              <p className="text-xs text-gray-600">kalamjiacademy@gmail.com</p>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <span className="bg-[#1ba6db] p-2 rounded-md text-white"><FiPhone size={20} /></span>
            <div>
              <h1 className="font-semibold text-gray-700 text-sm">Phone</h1>
              <p className="text-xs text-gray-600">+91 9488440066</p>
            </div>
          </div>
        </div>
      </div>

      {/* Navbar Links */}
      <div className="flex justify-between items-center mt-4 border-b pb-3">
        <div className="space-x-6 text-md font-medium flex items-center">
          <Link to="/" className="text-gray-700 hover:text-white hover:bg-[#1ba6db] px-3 py-2 rounded-md transition">Home</Link>
          <Link to="/about-us" className="text-gray-700 hover:text-white hover:bg-[#1ba6db] px-3 py-2 rounded-md transition">About Us</Link>

          {/* Tuitions Dropdown */}
          <div className="relative group" onMouseEnter={() => setTuitionOpen(true)} onMouseLeave={() => setTuitionOpen(false)}>
            <Link to ={"/Tuitions"}>
            <button className="text-gray-700 hover:text-white hover:bg-[#1ba6db] px-3 py-2 rounded-md flex items-center">
              Tuitions
              <span className="ml-2">{tuitionOpen ? <FiChevronUp size={18} /> : <FiChevronDown size={18} />}</span>
            </button>
</Link>
            {tuitionOpen && (
              <div className="absolute left-0 mt-0.5 bg-white border border-gray-200 z-50 w-60 group-hover:block transition-all duration-300">
                {/* Board Exams */}
                <div className="relative group" onMouseEnter={() => setBoardExamOpen(true)} onMouseLeave={() => setBoardExamOpen(false)}>
                  <button className="px-4 py-2 text-sm font-medium flex justify-between w-full text-gray-700 hover:bg-[#1ba6db] hover:text-white transition">
                    Board Exams <MdOutlineKeyboardArrowRight size={18} />
                  </button>

                  {boardExamOpen && (
                    <div className="absolute left-full top-0 mt-0 bg-white border border-gray-200 w-40">
                      {["CBSE", "ICSE", "Stateboard"].map((item) => (
                        <Link key={item} to={`/${item.toLowerCase()}`} className="block px-4 py-2 text-sm text-gray-700 hover:bg-[#1ba6db] hover:text-white">
                          {item}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>  

                {/* Entrance Exams */}
                <div className="relative group" onMouseEnter={() => setEntranceExamOpen(true)} onMouseLeave={() => setEntranceExamOpen(false)}>
                  <button className="px-4 py-2 text-sm font-medium flex justify-between w-full text-gray-700 hover:bg-[#1ba6db] hover:text-white transition">
                    Entrance Exams <MdOutlineKeyboardArrowRight size={18} />
                  </button>
                  {entranceExamOpen && (
                    <div className="absolute left-full top-0 mt-0 bg-white border border-gray-200 w-40">
                      {["NEET", "IIT-JEE", "VITEE", "CMC"].map((item) => (
                        <Link key={item} to={`/${item.toLowerCase()}`} className="block px-4 py-2 text-sm text-gray-700 hover:bg-[#1ba6db] hover:text-white">
                          {item}
                        </Link>
                      ))}
                    </div> 
                  )}
                </div>

                {/* Competitive Exams */}
                <div className="relative group" onMouseEnter={() => setCompetitiveExamOpen(true)} onMouseLeave={() => setCompetitiveExamOpen(false)}>
                  <button className="px-4 py-2 text-sm font-medium flex justify-between w-full text-gray-700 hover:bg-[#1ba6db] hover:text-white transition">
                    Competitive Exams <MdOutlineKeyboardArrowRight size={18} />
                  </button>
                  {competitiveExamOpen && (
                    <div className="absolute left-full top-0 mt-0 bg-white border border-gray-200 w-40">
                      {["UPSC", "TNPSC"].map((item) => (
                        <Link key={item} to={`/${item.toLowerCase()}`} className="block px-4 py-2 text-sm text-gray-700 hover:bg-[#1ba6db] hover:text-white">
                          {item}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>    
          <Link to="/gallery" className="text-gray-700 hover:text-white hover:bg-[#1ba6db] px-3 py-2 rounded-md transition">Gallery</Link>
          <Link to="/blog" className="text-gray-700 hover:text-white hover:bg-[#1ba6db] px-3 py-2 rounded-md transition">Blog</Link>
        </div>

        {/* Contact Button */}
        <Link to="/contact" className="bg-[#1ba6db] text-white font-medium px-4 py-2 rounded-2xl hover:bg-blue-600 transition">
          Contact Us
        </Link>
        
      </div>

            
    </div>
  );
};

export default Navbar;
